<template>
  <div class="management-contract">
    <el-form label-width="80px" inline>
      <el-form-item>
        <el-button type="primary" @click="addProgramme" style="margin-left:20px;">新增健康方案</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border>
      <el-table-column
        prop="hosName"
        label="医院名称"
        width="200"
      ></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="age" label="年龄"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="200"
        :formatter="formattercreateTime"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            @click.prevent="showCheckDialog(scope.row.id)"
            type="primary"
            size="small"
            >详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    showCheckDialog(id) {
      this.$router.push({ path: "addProgramme", query: { detailsId: id } });
    },
    formattercreateTime(row) {
      return this.getDate(row.createTime);
    },
    getDate(tm) {
      var tt = new Date(parseInt(tm))
        .toLocaleString()
        .replace(/年|月/g, "-")
        .replace(/日/g, "        ");
      return tt;
    },
    addProgramme() {
      let _this = this;
      this.$router.push({
        path: "addProgramme",
        query: { id: _this.$route.query.id },
      });
    },
    init() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.member.health.manager.scheme.list",
          source: "SANBOYUN",
          memberId: _this.$route.query.id,
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            _this.list = list;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
  },
};
</script>

<style lang="scss">
.management-contract {
  .el-form {
    padding-top: 22px;
    border-top: 1px solid #f5f5f5;
  }
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
